<template>
    <div class="range-field">
        <label for="grade">
          {{ label }}
          <span v-if="subtitle">{{ subtitle }}</span>
        </label>
        <div class="input-rangewrapper">
            <input type="range"
                   :min="min"
                   :max="max"
                   :step="step"
                   id="grade"
                   :name="name"
                   v-model="selectValue"
                   @input="rangeSliding"
                   class="input-range"
            />
            <div class="input-range__dots">
                <span v-for="n in max"></span>
            </div>
            <div class="selector" ref="selector" style="left: calc(0% - -16px);">
                <div class="selector__button">
                    <div class="selector__button__stripes">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <div class="selector__value">
                    {{ selectValue }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RangeSlider",
    props: [
        'label',
        'modelValue',
        'min',
        'max',
        'name',
        'default',
        'step',
        'subtitle',
    ],
    data() {
        return {
            range: this.max - this.min,
            selectValue: this.modelValue || this.default,
            showOverlay: false,
            thumbWidth: 32
        }
    },
    mounted () {
        // this.rangeSliding()
    },
    methods: {
        rangeSliding() {
            const position = ((this.selectValue - this.min) / this.range) * 100;
            const positionOffset = Math.round(this.thumbWidth * position / 100) - (this.thumbWidth / 2);
            console.log('range sliding', position, positionOffset, this.selectValue, this.min, this.range);
            this.$refs.selector.style.left = `calc(${position}% - ${positionOffset}px)`;

            this.$emit('update:modelValue', this.selectValue);
        }
    }
}
</script>

<style scoped>
    label {
        margin-bottom: 24px;
    }
    .range-field {
        margin-bottom: 56px;
    }
    .input-rangewrapper {
        position: relative;
        --thumbWidth: 32px;
    }

    .input-range {
        -webkit-appearance: none; 
        width: 100%;
        height: 8px;
        border-radius: 8px;
        background-color: #e6e6e6;
    }

    .input-range[type="range"]::-webkit-slider-thumb {
        -webkit-appearance: none;
        width: var(--thumbWidth);
        height: var(--thumbWidth);
        cursor: pointer;
        position: relative;
        z-index: 3;
        border-radius: 50%;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08);
        border: solid 1px #dadde2;
        background-color: transparent;
    }

    .input-range__dots {
        display: flex;
        justify-content: space-between;
        position: absolute;
        top: 50%;
        left: calc(var(--thumbWidth) / 2);
        right: calc(var(--thumbWidth) / 2);
        transform: translateY(-50%);
    }

    .input-range__dots span {
        display: block;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        opacity: 0.5;
        background-color: #fff;
    }

    .selector {
        position: absolute;
        bottom: -28px;
        width: var(--thumbWidth);
        transform: translateX(-50%);
        z-index: 2;
    }

    .selector__button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: var(--thumbWidth);
        height: 32px;
        border-radius: 50%;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08);
        border: solid 1px #dadde2;
        background-color: #fff;
    }

    .selector__button__stripes {
        display: flex;
        justify-content: space-between;
        width: 8px;
        height: 12px;
    }

    .selector__button__stripes span {
        display: inline-block;
        width: 1px;
        height: 100%;
        border-radius: 0.5px;
        background-color: #da503b;
    }

    .selector__value {
        text-align: center;
        margin-top: 6px;
        opacity: 0.8;
        font-size: 1.4rem;
    }
</style>
